<template>
    <v-container>
        <div class="flex-h" style="justify-content: space-between; align-items: center; margin-top: 10px; margin-bottom: 20px;">
            <div class="text-h3">Пакеты данных</div>
            <div style="margin-left: 20px;">
                <b>за</b>&nbsp;
                <DatePicker
                    v-model="dateFilterRange"
                    range
                    type="date"
                    :valueType="sqlDateTimeFormat"
                    :format="displayDateFormat"
                    range-separator=" — "
                />
            </div>
            <v-spacer />
        </div>

        <PacketBrowser
            ref="browser"
            :filters="filters"
        />
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import PacketBrowser from '@/components/browsers/PacketBrowser.vue'
import DatePicker from 'vue2-datepicker'
import {DISPLAY_DATE_FORMAT, setMidnight, SQL_DATE_TIME_FORMAT} from '@/utils/datetime'
import day from 'dayjs'

@Component({
    components: {DatePicker, PacketBrowser},
})
export default class PacketsView extends Vue
{
    sqlDateTimeFormat = SQL_DATE_TIME_FORMAT
    displayDateFormat = DISPLAY_DATE_FORMAT

    receivedSince: string | null = null
    receivedTill: string | null = null

    async created() {
        this.receivedSince = setMidnight(day().subtract(7, 'day')).format(this.sqlDateTimeFormat)
        this.receivedTill = setMidnight(day()).format(this.sqlDateTimeFormat)
    }

    get dateFilterRange(): [string, string] {
        return [this.receivedSince || '', this.receivedTill || '']
    }

    // noinspection JSUnusedGlobalSymbols
    set dateFilterRange([since, till]: [string, string]) {
        this.receivedSince = since
        this.receivedTill = till
    }

    get filters() {
        return {
            receivedSince: this.receivedSince
                ? day(this.receivedSince, this.sqlDateTimeFormat).utc().format(this.sqlDateTimeFormat)
                : null,
            receivedTill: this.receivedTill
                ? day(this.receivedTill, this.sqlDateTimeFormat).utc().add(1, 'day').format(this.sqlDateTimeFormat)
                : null,
        }
    }
}
</script>
